<template>
  <div class="studio-lessons-preview" v-bind="$attrs" v-on="$listeners">
    <h1 class="mb-4">
      {{ data.title }}
    </h1>
    <router-link
      v-for="(lesson, index) in limitedLessons"
      :key="lesson.id"
      class="undecorated-router-link mt-2"
      :to="{
        name: 'studio-product-lessons',
        query: { selected_lesson: index },
      }"
    >
      <StudioLessonCard
        class="mb-2"
        :lesson="lesson"
        :index="index + 1"
        :total="lessons.length"
        :isSelected="false"
        :hasAccess="canViewProductContent"
      >
      </StudioLessonCard>
    </router-link>
    <div v-if="remainingLessonsLength > 0" class="mt-2">
      <router-link
        class="undecorated-router-link mt-2"
        :to="{ name: 'studio-product-lessons' }"
      >
        <i class="fa fa-calendar-o c-brand-color mr-2"></i>
        {{
          $tc('PRODUCTS.LABELS.MORE_LESSONS_VARIANT', remainingLessonsLength, {
            remainingLessonsLength,
          })
        }}
      </router-link>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import StudioLessonCard from '@/web/components/products/StudioLessonCard';

export default Vue.extend({
  name: 'StudioLessonsPreview',
  components: {
    StudioLessonCard,
  },
  props: {
    limit: {
      type: Number,
      default: 3,
    },
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      product: 'product/product',
      canViewProductContent: 'product/canViewProductContent',
    }),
    lessons() {
      return this.product.lessons;
    },
    limitedLessons() {
      return this.lessons.slice(0, this.limit);
    },
    remainingLessonsLength() {
      return Math.max(0, this.lessons.length - this.limit);
    },
  },
});
</script>

<style lang="scss" scoped></style>
